import { Button, SelectionBar } from '@skupreme/shared/ui';
import type { ReactNode } from 'react';
import type { SuggestionView } from '../../lib/suggestion-types';
import { GatedButton } from './GatedButton';

export type BulkAction = 'confirm' | 'skip' | 'restore';

const BULK_ACTIONS: Record<
  SuggestionView,
  { action: BulkAction; label: string }[]
> = {
  to_review: [
    { action: 'confirm', label: 'Confirm' },
    { action: 'skip', label: 'Skip' },
  ],
  no_match: [{ action: 'skip', label: 'Skip' }],
  skipped: [{ action: 'restore', label: 'Restore' }],
};

export type BulkBarProps = {
  view: SuggestionView;
  count: number;
  onAction: (action: BulkAction) => void;
  onClear: () => void;
  /** Only the To review queue has confidence to select by. */
  onSelectHighConfidence?: () => void;
  isSelectingHigh?: boolean;
  isReadOnly?: boolean;
  isBusy?: boolean;
  children?: ReactNode;
};

/** The selection's count and its actions: "Confirm 12", "Skip 12". */
export function BulkBar({
  view,
  count,
  onAction,
  onClear,
  onSelectHighConfidence,
  isSelectingHigh,
  isReadOnly,
  isBusy,
}: BulkBarProps) {
  return (
    <div className="sk:flex sk:flex-wrap sk:items-center sk:gap-3">
      <SelectionBar
        count={count}
        emptyLabel="Tick listings to act on several at once"
        isBusy={isBusy}
        onCancel={onClear}
      >
        {count > 0
          ? BULK_ACTIONS[view].map(({ action, label }) => (
              <GatedButton
                key={action}
                variant={action === 'confirm' ? 'primary' : 'pill'}
                size="sm"
                isReadOnly={isReadOnly}
                isDisabled={isBusy}
                onPress={() => onAction(action)}
              >
                {label} {count}
              </GatedButton>
            ))
          : null}
      </SelectionBar>
      {onSelectHighConfidence ? (
        <Button
          variant="ghost"
          size="sm"
          isDisabled={isBusy || isSelectingHigh}
          onPress={onSelectHighConfidence}
        >
          {isSelectingHigh ? 'Selecting…' : 'Select all high confidence'}
        </Button>
      ) : null}
    </div>
  );
}
